import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { SeoForPage } from "../components/Seo";
import { LegalDocumentView } from "../legal/LegalDocument";
import { getTerms } from "../legal/terms";
import { useLang, useT } from "../lib/i18n";

export function Terms() {
  const lang = useLang();
  const t = useT();
  const doc = getTerms(lang);

  return (
    <div className="min-h-screen flex flex-col">
      <SeoForPage page="terms" path="/terms" />
      <Header />
      <main className="flex-1">
        <section className="border-b border-margin dark:border-paper/10">
          <div className="mx-auto max-w-3xl px-6 pt-20 pb-16 sm:pt-24 sm:pb-20">
            <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight text-ink dark:text-paper">
              {t.footer.terms}
            </h1>
            <div className="mt-10">
              <LegalDocumentView doc={doc} />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
